import React from "react";
import { Logo } from "./Logo";
import { ArrowUpRight } from "lucide-react";

export const Footer = ({ onQuote }) => {
  const go = (id) => {
    const el = document.getElementById(id);
    if (el) window.dispatchEvent(new CustomEvent("lenis-scroll-to", { detail: el }));
  };
  return (
    <footer className="relative bg-background border-t border-border" data-testid="site-footer">
      {/* Big CTA band */}
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-20 md:py-28 border-b border-border">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
          <h2 className="font-display font-black uppercase tracking-tighter text-[13vw] lg:text-[8rem] leading-[0.82] text-foreground">
            Let's build<br /><span className="text-primary">together</span>
          </h2>
          <button
            onClick={onQuote}
            data-testid="footer-quote-btn"
            className="group shrink-0 inline-flex items-center gap-3 bg-accent text-accent-foreground px-9 py-5 font-mono-tech text-xs tracking-[0.2em] uppercase hover:bg-foreground hover:text-background transition-colors duration-300"
          >
            Request a Quote
            <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </button>
        </div>
      </div>

      <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-14 grid md:grid-cols-[1.4fr_1fr_1fr] gap-12">
        <div>
          <Logo />
          <p className="mt-6 max-w-sm text-steel text-sm leading-relaxed">
            Anchor Point Industries LLC — PVF and industrial supply for contractors.
            Your single source for pipe, valves, fittings, gaskets, fasteners and jobsite materials.
          </p>
        </div>
        <div>
          <span className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-steel">Navigate</span>
          <ul className="mt-5 space-y-3">
            {[["Capabilities", "capabilities"], ["Approach", "approach"], ["Industries", "industries"], ["Contact", "contact"]].map(([l, id]) => (
              <li key={id}>
                <button onClick={() => go(id)} className="text-foreground hover:text-primary transition-colors text-sm">{l}</button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <span className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-steel">Contact</span>
          <ul className="mt-5 space-y-3 text-sm text-foreground">
            <li>estimating@anchorpointind.com</li>
            <li>956.844.0676</li>
            <li className="text-steel">Gulf Coast · Nationwide</li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-6 border-t border-border flex flex-col md:flex-row justify-between gap-2 font-mono-tech text-[10px] tracking-[0.2em] uppercase text-steel">
        <span>© {new Date().getFullYear()} Anchor Point Industries LLC</span>
        <span>PVF · Industrial Supply · Procurement</span>
      </div>
    </footer>
  );
};
